// --- Wishlist: site-wide storage helpers ---
function wwpGetWishlist() {
  try {
    return JSON.parse(localStorage.getItem('wwp_wishlist') || '[]');
  } catch (e) {
    return [];
  }
}
function wwpSetWishlist(list) {
  localStorage.setItem('wwp_wishlist', JSON.stringify(list));
}
window.wwpToggleWishlist = function (handle) {
  var list = wwpGetWishlist();
  var i = list.indexOf(handle);
  if (i > -1) {
    list.splice(i, 1);
  } else {
    list.push(handle);
  }
  wwpSetWishlist(list);
  document.dispatchEvent(new CustomEvent('wwp:wishlist-change', { detail: { handle: handle, list: list } }));
  return list.indexOf(handle) > -1;
};
window.wwpIsWishlisted = function (handle) {
  return wwpGetWishlist().indexOf(handle) > -1;
};

document.addEventListener('DOMContentLoaded', function () {
  var overlay = document.querySelector('[data-wwp-contact-overlay]');
  if (overlay) {
    var openers = document.querySelectorAll('[data-wwp-contact-open]');
    var closer = overlay.querySelector('[data-wwp-contact-close]');
    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      });
    });
    if (closer) {
      closer.addEventListener('click', function () {
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) {
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  var showFormBtn = document.querySelector('[data-wwp-show-form]');
  var formPanel = document.querySelector('[data-wwp-form-panel]');
  if (showFormBtn && formPanel) {
    showFormBtn.addEventListener('click', function () {
      formPanel.classList.toggle('is-visible');
    });
  }

  var chatBtn = document.querySelector('[data-wwp-open-chat]');
  if (chatBtn) {
    chatBtn.addEventListener('click', function () {
      var candidates = [
        '#chatty-widget-button', '.chatty-launcher', '.chatty-widget-launcher',
        '[id*="chatty"][id*="launcher"]', '[class*="chatty"][class*="launcher"]',
        '[id*="chatty"][id*="button"]', 'iframe[id*="chatty"]',
        '[id*="chat-widget"]', '[class*="chat-widget"]', '[id*="chatwidget"]'
      ];
      var opened = false;
      for (var i = 0; i < candidates.length; i++) {
        var el = document.querySelector(candidates[i]);
        if (el) {
          el.click();
          opened = true;
          break;
        }
      }
      if (overlay) {
        overlay.classList.remove('is-open');
        document.body.style.overflow = '';
      }
      if (!opened) {
        console.warn('We Wuv Pets: could not auto-locate the Chatty widget launcher, falling back to the contact form.');
        if (overlay) {
          overlay.classList.add('is-open');
          document.body.style.overflow = 'hidden';
        }
        if (formPanel) {
          formPanel.classList.add('is-visible');
        }
      }
    });
  }

  var drawer = document.getElementById('Details-menu-drawer-container');
  if (drawer) {
    drawer.addEventListener('toggle', function () {
      if (!drawer.open) {
        document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet', 'overflow-hidden-mobile');
        document.body.style.overflow = '';
      }
    });
  }

  // --- Colour swatch renderer ---
  var WWP_COLORS = {
    'black': '#000000', 'white': '#FFFFFF', 'gray': '#808080', 'grey': '#808080', 'gery': '#808080',
    'light gray': '#D3D3D3', 'light grey': '#D3D3D3', 'dark gray': '#4A4A4A', 'dark grey': '#4A4A4A',
    'red': '#E53935', 'blue': '#1E88E5', 'green': '#43A047', 'yellow': '#FDD835',
    'pink': '#EC407A', 'light pink': '#F8BBD0', 'dark pink': '#D81B60', 'leather pink': '#EC407A',
    'rose red': '#C2185B', 'orange': '#FB8C00', 'purple': '#8E24AA', 'light purple': '#CE93D8',
    'brown': '#795548', 'coffee': '#6F4E37', 'dark coffee': '#4E342E',
    'khaki': '#C3B091', 'dark khaki': '#8B7D3A', 'beige': '#E8DCC4', 'apricot': '#FBCEB1',
    'champagne': '#F7E7CE', 'gold': '#D4AF37', 'gold frame': '#D4AF37', 'bone': '#E3DAC9',
    'sky blue': '#87CEEB', 'light blue': '#ADD8E6', 'dark blue': '#00008B', 'deep blue': '#003399',
    'navy blue': '#000080', 'lake blue': '#4A6FA5', 'sapphire blue': '#0F52BA', 'turquoise': '#40E0D0',
    'light green': '#90EE90', 'dark green': '#006400', 'fruit green': '#8DB600',
    'fluorescent green': '#7FFF00', 'wine red': '#722F37', 'watermelon red': '#FC6C85',
    'watermelon green': '#4CBB17', 'rainbow': 'linear-gradient(90deg,red,orange,yellow,green,blue,purple)',
    'camouflage': '#78866B', 'silver': '#C0C0C0', 'cream': '#FFFDD0', 'tan': '#D2B48C', 'ivory': '#FFFFF0',
    'black frame': '#000000', 'blue reflective': '#1E88E5', 'gradient blue': '#4A6FA5', 'colorful': 'linear-gradient(90deg,red,orange,yellow,green,blue,purple)'
  };

  function wwpNormalize(text) {
    return text.toLowerCase().trim().replace(/\s*\d+$/, '').trim();
  }

  function wwpMatchColor(text) {
    var n = wwpNormalize(text);
    if (WWP_COLORS[n]) return WWP_COLORS[n];
    var keys = Object.keys(WWP_COLORS).sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < keys.length; i++) {
      if (n.indexOf(keys[i]) !== -1) return WWP_COLORS[keys[i]];
    }
    return null;
  }

  function wwpPaintSwatches() {
    document.querySelectorAll('fieldset.product-form__input--swatch').forEach(function (fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!legend) return;
      var labelText = legend.textContent.toLowerCase();
      if (labelText.indexOf('color') === -1 && labelText.indexOf('colour') === -1) return;
      fieldset.querySelectorAll('.color-swatch').forEach(function (swatchEl) {
        var labelSpan = swatchEl.querySelector('.color-swatch__label');
        if (!labelSpan) return;
        var text = labelSpan.textContent;
        var color = wwpMatchColor(text);
        if (color) {
          swatchEl.style.background = color;
          swatchEl.style.border = '1px solid rgba(0,0,0,0.15)';
          labelSpan.classList.add('visually-hidden');
        }
      });
    });
  }

  wwpPaintSwatches();
  document.addEventListener('variant:change', wwpPaintSwatches);
  var vs = document.querySelector('variant-selects');
  if (vs) {
    var obs = new MutationObserver(wwpPaintSwatches);
    obs.observe(vs, { childList: true, subtree: true });
  }

  // --- Canine/Feline Collection badge on the product page title ---
  if (window.wwpProductCollectionBadge) {
    var titleEl = document.querySelector('.product__title h1');
    if (titleEl && !document.querySelector('.wwp-cert-badge')) {
      var badge = document.createElement('span');
      badge.className = 'wwp-cert-badge';
      badge.textContent = '\uD83D\uDC3E ' + window.wwpProductCollectionBadge;
      titleEl.insertAdjacentElement('afterend', badge);
    }
  }

  // --- Price range slider ---
  function wwpBuildPriceSliders() {
    document.querySelectorAll('price-range').forEach(function (el) {
      if (el.dataset.wwpSliderBuilt) return;
      var inputs = el.querySelectorAll('input[type="number"]');
      if (inputs.length !== 2) return;
      var minInput = inputs[0];
      var maxInput = inputs[1];
      var min = parseFloat(minInput.min) || 0;
      var max = parseFloat(maxInput.max) || 1000;
      if (max <= min) return;
      var minVal = minInput.value !== '' ? parseFloat(minInput.value) : min;
      var maxVal = maxInput.value !== '' ? parseFloat(maxInput.value) : max;

      var wrap = document.createElement('div');
      wrap.className = 'wwp-price-slider';
      wrap.innerHTML =
        '<div class="wwp-price-slider__values">' +
          '<span class="wwp-price-slider__min-label"></span>' +
          '<span class="wwp-price-slider__max-label"></span>' +
        '</div>' +
        '<div class="wwp-price-slider__track"></div>' +
        '<div class="wwp-price-slider__range"></div>' +
        '<input type="range" class="wwp-range-min" min="' + min + '" max="' + max + '" value="' + minVal + '" step="1">' +
        '<input type="range" class="wwp-range-max" min="' + min + '" max="' + max + '" value="' + maxVal + '" step="1">';

      el.insertAdjacentElement('afterbegin', wrap);

      var rangeMin = wrap.querySelector('.wwp-range-min');
      var rangeMax = wrap.querySelector('.wwp-range-max');
      var rangeTrack = wrap.querySelector('.wwp-price-slider__range');
      var minLabel = wrap.querySelector('.wwp-price-slider__min-label');
      var maxLabel = wrap.querySelector('.wwp-price-slider__max-label');

      function currencySymbol() {
        var symEl = el.parentElement && el.parentElement.querySelector('.field-currency');
        return (symEl && symEl.textContent.trim()) || '£';
      }
      var sym = currencySymbol();

      function updateVisual() {
        var lo = parseFloat(rangeMin.value);
        var hi = parseFloat(rangeMax.value);
        if (lo > hi) {
          var tmp = lo; lo = hi; hi = tmp;
        }
        var pctLo = ((lo - min) / (max - min)) * 100;
        var pctHi = ((hi - min) / (max - min)) * 100;
        rangeTrack.style.left = pctLo + '%';
        rangeTrack.style.width = (pctHi - pctLo) + '%';
        minLabel.textContent = sym + lo.toFixed(0);
        maxLabel.textContent = sym + hi.toFixed(0);
      }

      function commit() {
        var lo = Math.min(parseFloat(rangeMin.value), parseFloat(rangeMax.value));
        var hi = Math.max(parseFloat(rangeMin.value), parseFloat(rangeMax.value));
        minInput.value = lo;
        maxInput.value = hi;
        minInput.dispatchEvent(new Event('change', { bubbles: true }));
        maxInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      rangeMin.addEventListener('input', updateVisual);
      rangeMax.addEventListener('input', updateVisual);
      rangeMin.addEventListener('change', commit);
      rangeMax.addEventListener('change', commit);

      updateVisual();
      el.dataset.wwpSliderBuilt = 'true';
    });
  }

  wwpBuildPriceSliders();
  var facetsContainer = document.querySelector('.facets-container');
  if (facetsContainer) {
    var priceObs = new MutationObserver(wwpBuildPriceSliders);
    priceObs.observe(facetsContainer, { childList: true, subtree: true });
  }

  document.addEventListener('toggle', function (e) {
    if (e.target && e.target.tagName === 'DETAILS') {
      wwpBuildPriceSliders();
    }
  }, true);

  var mobileFacetsWrapper = document.querySelector('.mobile-facets__wrapper');
  if (mobileFacetsWrapper) {
    mobileFacetsWrapper.addEventListener('toggle', wwpBuildPriceSliders, true);
  }

  // --- Wishlist heart buttons ---
  function wwpHeartSVG(filled) {
    return '<svg viewBox="0 0 24 24" width="18" height="18" fill="' + (filled ? '#E0948F' : 'none') + '" stroke="#E0948F" stroke-width="1.8"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  }

  function wwpRefreshHeart(btn) {
    var handle = btn.dataset.wwpWishlistHandle;
    var isSaved = window.wwpIsWishlisted(handle);
    btn.classList.toggle('is-active', isSaved);
    btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    if (btn.hasAttribute('data-wwp-pdp-heart')) {
      btn.innerHTML = wwpHeartSVG(isSaved) + '<span class="wwp-wishlist-heart__label">' + (isSaved ? 'Saved to Wishlist' : 'Save to Wishlist') + '</span>';
      btn.setAttribute('aria-label', isSaved ? 'Remove from wishlist' : 'Save to wishlist');
    } else {
      btn.innerHTML = wwpHeartSVG(isSaved);
      btn.setAttribute('aria-label', isSaved ? 'Remove from wishlist' : 'Save to wishlist');
    }
  }

  function wwpBindHeartButtons(root) {
    (root || document).querySelectorAll('[data-wwp-wishlist-handle]').forEach(function (btn) {
      if (btn.dataset.wwpBound) return;
      btn.dataset.wwpBound = 'true';
      wwpRefreshHeart(btn);
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.wwpToggleWishlist(btn.dataset.wwpWishlistHandle);
        wwpRefreshHeart(btn);
      });
    });
  }

  wwpBindHeartButtons();
  document.addEventListener('wwp:wishlist-change', function () {
    document.querySelectorAll('[data-wwp-wishlist-handle]').forEach(wwpRefreshHeart);
  });

  if (window.wwpProductHandle) {
    var pTitleEl = document.querySelector('.product__title h1');
    if (pTitleEl && !document.querySelector('[data-wwp-wishlist-handle][data-wwp-pdp-heart]')) {
      var pHeartBtn = document.createElement('button');
      pHeartBtn.type = 'button';
      pHeartBtn.className = 'wwp-wishlist-heart wwp-wishlist-heart--pdp';
      pHeartBtn.setAttribute('data-wwp-wishlist-handle', window.wwpProductHandle);
      pHeartBtn.setAttribute('data-wwp-pdp-heart', 'true');
      pTitleEl.insertAdjacentElement('afterend', pHeartBtn);
      wwpBindHeartButtons();
    }
  }

  var wwpCardsObs = new MutationObserver(function () { wwpBindHeartButtons(); wwpBindInlineQuickAdd(); });
  wwpCardsObs.observe(document.body, { childList: true, subtree: true });

  // --- Inline quick-add: dropdowns + AJAX add-to-cart ---
  function wwpBindInlineQuickAdd(root) {
    (root || document).querySelectorAll('[data-wwp-inline-quickadd-toggle]').forEach(function (btn) {
      if (btn.dataset.wwpQaBound) return;
      btn.dataset.wwpQaBound = 'true';
      btn.addEventListener('click', function () {
        var panel = document.getElementById('WwpInlineQuickAdd-' + btn.dataset.wwpInlineQuickaddToggle);
        if (!panel) return;
        var isOpen = !panel.hidden;
        document.querySelectorAll('[data-wwp-inline-quickadd]').forEach(function (p) {
          if (p !== panel) p.hidden = true;
        });
        document.querySelectorAll('[data-wwp-inline-quickadd-toggle]').forEach(function (b) {
          if (b !== btn) b.setAttribute('aria-expanded', 'false');
        });
        panel.hidden = isOpen;
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    });

    (root || document).querySelectorAll('[data-wwp-inline-quickadd]').forEach(function (panel) {
      if (panel.dataset.wwpQaBound) return;
      panel.dataset.wwpQaBound = 'true';

      var variantsScript = panel.querySelector('[data-wwp-qa-variants]');
      var variants = [];
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) {}

      var selects = panel.querySelectorAll('[data-wwp-qa-option]');
      var addBtn = panel.querySelector('[data-wwp-qa-add]');
      var msgEl = panel.querySelector('[data-wwp-qa-msg]');

      function findVariant() {
        var chosen = [];
        selects.forEach(function (sel) { chosen.push(sel.value); });
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });
      }

      function updateAvailability() {
        var match = findVariant();
        if (!match) {
          addBtn.disabled = true;
          addBtn.querySelector('span').textContent = 'Unavailable';
        } else if (!match.available) {
          addBtn.disabled = true;
          addBtn.querySelector('span').textContent = 'Sold out';
        } else {
          addBtn.disabled = false;
          addBtn.querySelector('span').textContent = 'Add to Cart';
        }
      }

      selects.forEach(function (sel) {
        sel.addEventListener('change', updateAvailability);
      });
      updateAvailability();

      addBtn.addEventListener('click', function () {
        var match = findVariant();
        if (!match || !match.available) return;

        addBtn.disabled = true;
        var originalText = addBtn.querySelector('span').textContent;
        addBtn.querySelector('span').textContent = 'Adding...';

        fetch(window.Shopify && window.routes ? window.routes.cart_add_url : '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: match.id, quantity: 1 }] })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.status) {
              msgEl.textContent = data.description || 'Something went wrong. Please try again.';
              msgEl.hidden = false;
              addBtn.disabled = false;
              addBtn.querySelector('span').textContent = originalText;
              return;
            }
            msgEl.textContent = 'Added to cart!';
            msgEl.hidden = false;
            addBtn.querySelector('span').textContent = 'Added ✓';
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            var cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
            if (cartNotification && typeof cartNotification.renderContents === 'function') {
              fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
                cartNotification.renderContents({ sections: {}, cart: cart });
              }).catch(function () {});
            }
            setTimeout(function () {
              addBtn.disabled = false;
              addBtn.querySelector('span').textContent = originalText;
              msgEl.hidden = true;
            }, 2500);
          })
          .catch(function () {
            msgEl.textContent = 'Something went wrong. Please try again.';
            msgEl.hidden = false;
            addBtn.disabled = false;
            addBtn.querySelector('span').textContent = originalText;
          });
      });
    });
  }

  wwpBindInlineQuickAdd();


  // --- Product description FAQ: convert to a real collapsible accordion ---
  // Our description template always writes FAQ as:
  //   <p><strong>FAQ</strong></p><p><em>Question?</em> Answer text<br><em>Question 2?</em> Answer text...</p>
  // This finds that pattern and rebuilds it as proper <details>/<summary> rows.
  function wwpBuildFaqAccordion() {
    var desc = document.querySelector('.product__description');
    if (!desc || desc.dataset.wwpFaqBuilt) return;

    var paragraphs = Array.prototype.slice.call(desc.querySelectorAll('p'));
    var faqHeadingIndex = -1;
    for (var i = 0; i < paragraphs.length; i++) {
      var strongEl = paragraphs[i].querySelector('strong');
      if (strongEl && strongEl.textContent.trim().toUpperCase() === 'FAQ') {
        faqHeadingIndex = i;
        break;
      }
    }
    if (faqHeadingIndex === -1) return;

    var headingP = paragraphs[faqHeadingIndex];
    var faqParagraphs = paragraphs.slice(faqHeadingIndex + 1);
    if (!faqParagraphs.length) return;

    var combinedHtml = faqParagraphs.map(function (p) { return p.innerHTML; }).join('<br>');
    var re = /<em>([\s\S]*?)<\/em>\s*([\s\S]*?)(?=(<em>)|$)/gi;
    var pairs = [];
    var match;
    while ((match = re.exec(combinedHtml)) !== null) {
      var q = match[1].replace(/<[^>]+>/g, '').trim();
      var a = match[2].replace(/^<br\s*\/?>/i, '').replace(/<br\s*\/?>\s*$/i, '').trim();
      if (q && a) pairs.push({ q: q, a: a });
    }
    if (!pairs.length) return;

    var accordion = document.createElement('div');
    accordion.className = 'wwp-faq-accordion';
    pairs.forEach(function (pair, idx) {
      var details = document.createElement('details');
      details.className = 'wwp-faq-item';
      if (idx === 0) details.open = true;
      var summary = document.createElement('summary');
      summary.className = 'wwp-faq-question';
      summary.textContent = pair.q;
      var answer = document.createElement('div');
      answer.className = 'wwp-faq-answer';
      answer.innerHTML = pair.a;
      details.appendChild(summary);
      details.appendChild(answer);
      accordion.appendChild(details);
    });

    if (pairs.length < 3) {
      console.warn('We Wuv Pets: FAQ on this product has only ' + pairs.length + ' question(s) — should have at least 3.', window.location.pathname);
    }

    headingP.parentNode.insertBefore(accordion, headingP);
    faqParagraphs.forEach(function (p) { p.remove(); });
    headingP.remove();
    desc.dataset.wwpFaqBuilt = 'true';
  }

  wwpBuildFaqAccordion();

  // --- Brand "Wuv" styling: highlight "Wuv" with a paw accent, matching the logo treatment ---
  function wwpStyleWuvBrand() {
    var targets = document.querySelectorAll(
      '.product__description strong, .collection-hero__title, .wwp-bundle-crosssell__title, main h1'
    );
    targets.forEach(function (el) {
      if (el.dataset.wwpWuvStyled) return;
      if (!/\bWuv\b/.test(el.textContent)) return;
      el.dataset.wwpWuvStyled = 'true';
      el.innerHTML = el.innerHTML.replace(
        /\bWuv\b/g,
        '<span class="wwp-brand-wuv">Wuv<svg class="wwp-brand-wuv__paw" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="15" r="5"/><circle cx="5" cy="9" r="2.4"/><circle cx="10" cy="4.5" r="2.4"/><circle cx="14" cy="4.5" r="2.4"/><circle cx="19" cy="9" r="2.4"/></svg></span>'
      );
    });
  }

  wwpStyleWuvBrand();

  // --- Product image modal: build swipe dots + wire prev/next arrows ---
  function wwpSetupModalSwipe(modalEl) {
    if (modalEl.dataset.wwpSwipeBuilt) return;
    var scroller = modalEl.querySelector('[data-wwp-modal-scroller]');
    var dotsWrap = modalEl.querySelector('[data-wwp-modal-dots]');
    var prevBtn = modalEl.querySelector('[data-wwp-modal-prev]');
    var nextBtn = modalEl.querySelector('[data-wwp-modal-next]');
    if (!scroller || !dotsWrap) return;

    function getItems() {
      return Array.prototype.slice.call(scroller.children).filter(function (el) {
        return el.hasAttribute('data-media-id');
      });
    }

    function buildDots() {
      var items = getItems();
      dotsWrap.innerHTML = '';
      if (items.length <= 1) return;
      items.forEach(function () {
        var dot = document.createElement('span');
        dotsWrap.appendChild(dot);
      });
    }

    function currentIndex() {
      var items = getItems();
      var scrollerRect = scroller.getBoundingClientRect();
      var mid = scrollerRect.left + scrollerRect.width / 2;
      var closest = 0;
      var closestDist = Infinity;
      items.forEach(function (el, i) {
        var r = el.getBoundingClientRect();
        var center = r.left + r.width / 2;
        var dist = Math.abs(center - mid);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      return closest;
    }

    function updateActive() {
      var items = getItems();
      var idx = currentIndex();
      var dots = dotsWrap.querySelectorAll('span');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      if (prevBtn) prevBtn.hidden = idx <= 0;
      if (nextBtn) nextBtn.hidden = idx >= items.length - 1;
    }

    function goTo(idx) {
      var items = getItems();
      if (idx < 0 || idx >= items.length) return;
      items[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex() + 1); });

    var scrollTimer;
    scroller.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateActive, 80);
    });

    var observer = new MutationObserver(function () {
      buildDots();
      updateActive();
    });
    observer.observe(scroller, { attributes: true, attributeFilter: ['class'], subtree: true });

    buildDots();
    updateActive();
    modalEl.dataset.wwpSwipeBuilt = 'true';
  }

  document.querySelectorAll('product-modal').forEach(wwpSetupModalSwipe);
});
